import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { GlobalToken, theme } from 'antd';

const IconChevron = ({ className }: { className: string }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      d="M5.172 5.586l2.827 2.828 2.83-2.828L12.242 7l-2.83 2.828h.001L8 11.243 3.757 7l1.415-1.414z"
    />
  </svg>
);

const YearlyViewButton = ({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (isOpen: boolean) => void }) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  return (
    <StyledYearlyViewButton $isOpen={isOpen}>
      <a
        style={{ color: isOpen ? token.colorText : token.colorPrimary, display: 'flex' }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {t('Yearly View')}
        {isOpen ? <IconChevron className={'chevron-up'} /> : <IconChevron className={'chevron-down'} />}
      </a>
      <div className="arrow" />
    </StyledYearlyViewButton>
  );
};

interface StyledYearlyViewButtonProps {
  $isOpen: boolean;
  theme: { token: GlobalToken };
}

const StyledYearlyViewButton = styled.div<StyledYearlyViewButtonProps>`
  border-radius: 0 0 4px 4px;
  display: flex;
  align-items: center;
  height: 38px;
  width: 100%;
  font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  justify-content: center;
  background-color: ${({ theme: { token }, $isOpen }) => ($isOpen ? token.colorPrimary : '')};
  position: absolute;
  left: 0;
  bottom: 0;
  cursor: pointer;

  .arrow //Adds an arrow graphic to the yearly view component
  {
    visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    bottom: -106%;
    left: 41.5%;
    border: 38px solid transparent;
    border-top: none;
    border-bottom-color: ${({ theme: { token } }) => token.colorPrimary};
    &:after {
      visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      left: -31px;
      bottom: -34px;
      border: 31px solid transparent;
      border-top: none;
      border-bottom-color: ${({ theme: { token } }) => token.colorBgContainer};
      z-index: 2;
    }
  }

  .chevron-down {
    fill: ${({ theme: { token } }) => token.colorPrimary};
  }

  .chevron-up {
    fill: ${({ theme: { token } }) => token.colorText};
    transform: rotate(180deg);
  }
`;
export default YearlyViewButton;
